import React, { useState } from "react";

interface ServiceHeroProps {
  title: string;
  description: string;
  image: string;
  imageAlt: string;
  features: string[];
  pillars: string[];
}

const ServiceHero: React.FC<ServiceHeroProps> = ({
  title,
  description,
  image,
  imageAlt,
  features,
  pillars,
}) => {
  const [imageHovered, setImageHovered] = useState(false);

  return (
    <>
      <h2 
        className="details-content-title mb-15 wow fadeInUp" 
        data-wow-delay="100ms"
        style={{
          fontSize: "2.5rem",
          fontWeight: "700",
          color: "#ffffff",
          lineHeight: "1.3"
        }}
      >
        {title}
      </h2>
      <p 
        className="wow fadeInUp" 
        data-wow-delay="200ms"
        style={{
          fontSize: "17px",
          lineHeight: "1.8",
          color: "rgba(255,255,255,0.85)",
          marginBottom: "40px"
        }}
      >
        {description}
      </p>

      {/* IMAGE + LIST */}
      <div className="row mb-45 align-items-center mt-none-30">
        <div className="col-md-6 mt-30 wow fadeInLeft" data-wow-delay="300ms">
          <div
            style={{
              borderRadius: "16px",
              overflow: "hidden",
              background: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(255,255,255,0.12)",
              backdropFilter: "blur(10px)",
              padding: "10px",
              transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              transform: imageHovered ? "translateY(-8px) scale(1.02)" : "translateY(0) scale(1)",
              boxShadow: imageHovered ? "0 20px 40px rgba(255,140,0,0.3)" : "0 5px 15px rgba(0,0,0,0.1)",
            }}
            onMouseEnter={() => setImageHovered(true)}
            onMouseLeave={() => setImageHovered(false)}
          >
            <img 
              src={image} 
              alt={imageAlt} 
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "12px",
                display: "block"
              }}
            />
          </div>
        </div>

        <div className="col-md-6 mt-30 wow fadeInRight" data-wow-delay="400ms">
          <div
            style={{
              padding: "30px",
              borderRadius: "16px",
              background: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(255,255,255,0.12)",
              backdropFilter: "blur(10px)",
            }}
          >
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {features.map((feature, index) => (
                <li 
                  key={index}
                  className="wow fadeInUp"
                  data-wow-delay={`${500 + index * 80}ms`}
                  style={{
                    padding: "12px 0",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "rgba(255,255,255,0.9)",
                    borderBottom: index < features.length - 1 ? "1px solid rgba(255,255,255,0.08)" : "none",
                  }}
                >
                  <span style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, rgba(255,140,0,0.9), rgba(255,140,0,0.6))",
                    marginRight: "15px",
                    boxShadow: "0 2px 8px rgba(255,140,0,0.4)"
                  }}></span>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <h3 
        className="item_details_info_heading mb-25 wow fadeInUp" 
        data-wow-delay="900ms"
        style={{
          fontSize: "1.8rem",
          fontWeight: "600",
          color: "#ffffff",
          marginTop: "20px"
        }}
      >
        3 pillars of effective {imageAlt.toLowerCase()}
      </h3>

      <div
        className="wow fadeInUp"
        data-wow-delay="1000ms"
        style={{
          padding: "30px",
          borderRadius: "16px",
          background: "rgba(255,255,255,0.06)",
          border: "1px solid rgba(255,255,255,0.12)",
          backdropFilter: "blur(10px)",
        }}
      >
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {pillars.map((pillar, index) => (
            <li 
              key={index}
              className="wow fadeInUp"
              data-wow-delay={`${1100 + index * 100}ms`}
              style={{
                padding: "18px 20px",
                marginBottom: index < pillars.length - 1 ? "12px" : "0",
                display: "flex",
                alignItems: "flex-start",
                fontSize: "16px",
                fontWeight: "500",
                color: "rgba(255,255,255,0.9)",
                background: "rgba(255,255,255,0.03)",
                borderRadius: "12px",
                border: "1px solid rgba(255,255,255,0.08)",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateX(10px)";
                e.currentTarget.style.background = "rgba(255,140,0,0.1)";
                e.currentTarget.style.borderColor = "rgba(255,140,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateX(0)";
                e.currentTarget.style.background = "rgba(255,255,255,0.03)";
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.08)";
              }}
            >
              <span style={{
                minWidth: "28px",
                height: "28px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, rgba(255,140,0,0.9), rgba(255,140,0,0.6))",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "14px",
                fontWeight: "700",
                color: "#ffffff",
                marginRight: "15px",
                boxShadow: "0 2px 8px rgba(255,140,0,0.4)"
              }}>
                {index + 1}
              </span>
              {pillar}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default ServiceHero;
